import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1b203a;

  margin-bottom: 16px;

  &.link {
    font-size: 14px;
    font-weight: 400;
    color: #1371fe;
    text-decoration: underline;
    margin: 0;
  }

  &.description {
    font-size: 14px;
    font-weight: 400;
    color: #474d66;
    white-space: pre-wrap;
  }
`;

export const Link = styled.a`
  font-weight: 400;
  color: #1371fe;
  text-decoration: underline;
  margin: 0;
`;

interface IDivider {
  height: string;
}

export const Divider = styled.div<IDivider>`
  margin-top: ${({ height }) => height};
`;

export const DescriptionContainer = styled.div``;
